import { observable, action } from 'mobx'
import { Api } from 'utilities'
import { RootStore, GENERAL_STORE } from 'store'
import { Agreement, AgreementDTO, AgreementStatusTypes } from 'models'

export const AGREEMENT_STORE = 'AGREEMENT_STORE'

export class AgreementStore {
  rootStore: RootStore

  constructor (rootStore: RootStore) {
    this.rootStore = rootStore
  }

  @observable agreementsList: Agreement[] = []
  @observable agreementToView: Agreement = {} as Agreement

  @action.bound setAgreementsList (list: Agreement[] = []) {
    this.agreementsList = list
  }

  @action.bound setAgreementToView (agreement: Agreement = {} as Agreement) {
    this.agreementToView = agreement
  }

  getAgreements = () => {
    const {
      setLoadingOn, setLoadingOff, handleApiError
    } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .get('/agreement/all')
      .then((res: Agreement[]) => {
        this.setAgreementsList(res)
        setLoadingOff()
      })
      .catch(handleApiError)
  }

  createAgreement = (agreementDetails: Agreement | AgreementDTO) => {
    const {
      setLoadingOn, showSuccess, handleApiError, push
    } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    Api
      .post('/agreement/create', agreementDetails)
      .then((res: AgreementDTO) => {
        return Api.post(
          '/agreement/update',
          {
            ...res,
            budgetBuffer: agreementDetails.budgetBuffer,
            items: agreementDetails.items,
            scopes: agreementDetails.scopes,
            status: AgreementStatusTypes.ACTIVE
          }
        )
      })
      .then(() => {
        showSuccess('Agreement has been saved.')
        push('/agreements')
      })
      .catch(handleApiError)
  }

  getAgreementById = async (id: string | number) => {
    const {
      setLoadingOn, setLoadingOff, handleApiError
    } = this.rootStore[GENERAL_STORE]

    setLoadingOn()

    let agreement: AgreementDTO = null

    await Api
      .get(`/agreement/${id}/view`)
      .then((data: AgreementDTO) => {
        this.setAgreementToView(new Agreement(data as any))
        setLoadingOff()
        agreement = data
      })
      .catch(handleApiError)

    return agreement
  }

    editAgreement = (agreementDetails: Agreement | AgreementDTO) => {
      const {
        setLoadingOn, showSuccess, handleApiError, push
      } = this.rootStore[GENERAL_STORE]

      setLoadingOn()

      Api
        .post('/agreement/update', agreementDetails)
        .then(() => {
          showSuccess('Details saved.')
          push('/agreements')
        })
        .catch(handleApiError)
    }

    updateAgreementStatus = (id: number, status: AgreementStatusTypes) => {
      const {
        setLoadingOn, showSuccess, handleApiError, push
      } = this.rootStore[GENERAL_STORE]

      setLoadingOn()

      Api
        .put(`/agreement/${id}/agreementStatus`, { agreementStatus: status })
        .then(() => {
          showSuccess('Status updated.')
          push('/agreements')
        })
        .catch(handleApiError)
    }
}
